// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"c05fbef5","624":"5bf0282f"}[chunkId] + ".chunk.css";
};